import React from 'react'
import { format, getXigniteToStandard } from '../../../../../utils'

import './cell.component.scss'

const EMPTY_PLACEHOLDER = '-'

/**
 * Title Custom Cell Component
 * @param company
 * @param symbol
 * @param exchange
 * @returns {*}
 * @constructor
 */
const TitleCell = ({ name, symbol, exchange }) => {
  return (
    <div className='cell'>
      <div className='cell_ticker'>
        <span className='cell_ticker-item cell_ticker--symbol'>{symbol || EMPTY_PLACEHOLDER}</span>
        <span className='cell_ticker-item cell_ticker--exchange'>
          {exchange ? getXigniteToStandard(exchange) : EMPTY_PLACEHOLDER}
        </span>
      </div>
      <div className='cell_title'>{name || EMPTY_PLACEHOLDER}</div>
    </div>
  )
}

/**
 * AgGrid Custom Cell Render Component
 * @param data
 * @param column
 * @param onExpandMenuClick
 */
const CustomCell = ({ data = {}, column = {} }) => {
  const cellData = data[column.colId]

  switch (column.colId) {
    case 'organization':
      return <TitleCell {...data.organization} />
    case 'count':
      return cellData ? format(cellData) : EMPTY_PLACEHOLDER
    default:
      return cellData || EMPTY_PLACEHOLDER
  }
}

export default CustomCell
